// MUST be first: strips the `#handoff=<code>` fragment from the URL before
// vue-router (imported via App.vue/router.ts below) snapshots window.location
// and before any analytics initialises. See composables/handoffCapture.ts.
import { handoffCode } from "@composables/handoffCapture";

import {createApp} from 'vue';
//import { createApp } from 'vue/dist/vue.esm-bundler'
import '@styles/app.scss';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import bootstrap from './plugins/bootstrap';

import App from './App.vue';
import router from './router';
import store from "./store";
import i18n from "./i18n/index"
import {retrieveLaunchParams} from '@tma.js/sdk-vue';
import {initTg} from '@/initTg';
import ToastPlugin from 'vue-toast-notification';
import {useVpnConnector} from "@composables/vpnConnector";
import * as Sentry from "@sentry/vue";

// Mock the environment in case, we are outside Telegram.
import './mockEnv.ts'
import isInTelegram from "@/utils/isInTelegram";
import isCheckoutPopup from "@/utils/isCheckoutPopup";
import { initGtm } from "@/composables/gtm";
import { consumeHandoffCode, isOauthCallbackPath, setPendingHandoff } from "@composables/handoff";

// Configure all application dependencies.
const vpnConnector = useVpnConnector();
try {
	if (isInTelegram()) {
    	initTg(retrieveLaunchParams().startParam === 'debug' || import.meta.env.DEV)
	}
} catch (e) {
    if (!vpnConnector.isRouteRunVpn()) throw e;
}

const app = createApp(App);

if (!import.meta.env.DEV) {
    Sentry.init({
        app,
        dsn: "https://9ff06db63bfeb84d115bf81d9d1e63fa@o4508189659824128.ingest.de.sentry.io/4509013278654544",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.vueIntegration({
                tracingOptions: {
                    trackComponents: ["Header", "Navigation", "Footer"],
                    hooks: ["create", "mount"],
                },
            }),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            })
        ],
        tracesSampleRate: 0.2,
        attachStacktrace: true,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0
    });
}
app.use(store);
app.use(router);
app.use(i18n); //TODO Сделать предзагрузку переводов
app.use(ToastPlugin);
app.use(bootstrap);
initGtm(); // analytics — the handoff fragment is already stripped above

// Exchange the captured handoff code (if any) for a real session. Registered
// AFTER app.use(router), so the authApi store captures a valid router, and
// BEFORE the first navigation guard runs (the guard awaits it), so the
// now-authed user is routed correctly (redirect/promo). consumeHandoffCode
// checks for an existing session synchronously, so an active session is never
// silently overwritten. Skipped inside Telegram (web-only, top-level nav).
//
// Skipped in two cases, both because the code is single-use and someone else is
// the rightful consumer: the checkout's OAuth popup (the session belongs to the
// opener, login.vue forwards the code there) and the OAuth return routes (the
// page exchanges it itself, reporting the provider as the login method instead
// of the 'email' default used here).
const pendingHandoff = (handoffCode && !isInTelegram() && !isCheckoutPopup() && !isOauthCallbackPath())
    ? consumeHandoffCode(handoffCode)
    : null;
setPendingHandoff(pendingHandoff);

app.mount('#app');
